module.exports = __webpack_public_path__ + "media/src/images/bg/welcome-icon8-8e2d63fd4e96adf4f0168f53b547d9e6.png";